import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/tenant-settings/data-sources")({
  component: AdminDataSources,
});

function AdminDataSources() {
  return (
    <div className="p-4 xl:p-6">
      <p className="text-sm text-muted-foreground">
        团队级数据连接管理开发中...
      </p>
    </div>
  );
}
